// extracted by mini-css-extract-plugin
module.exports = {"demo":"style_demo__2ZnVa"};